import React, { useState, useCallback } from "react";
import axios from "axios";
import baseUrl from "../../config/baseUrl";

const inputStyle = {
  padding: "12px",
  width: "100%",
  marginBottom: "12px",
  borderRadius: "10px",
  border: "1px solid #ffffff30",
  backgroundColor: "#ffffff20",
  color: "#fff",
  fontSize: "15px",
  outline: "none",
  transition: "0.3s",
};

const buttonStyle = {
  padding: "12px 20px",
  background: "linear-gradient(135deg, #00c6ff, #0072ff)",
  color: "#fff",
  fontWeight: "bold",
  border: "none",
  borderRadius: "30px",
  cursor: "pointer",
  transition: "0.3s ease-in-out",
};

const MerchantQR = () => {
  const [form, setForm] = useState({ id: "", name: "", email: "" });
  const [qrCode, setQrCode] = useState(null);
  const [error, setError] = useState("");

  const handleChange = useCallback((e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }, []);

  const handleGenerate = async () => {
    setError("");
    const { email, id, name } = form;

    if (!email || !id || !name) {
      return setError("⚠️ All fields are required!");
    }

    try {
      const response = await axios.post(
        `${baseUrl}/merchantAuth`,
        { email, id, name },
        { responseType: "arraybuffer" }
      );

      const base64Image = btoa(
        new Uint8Array(response.data).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ""
        )
      );
      setQrCode(`data:image/png;base64,${base64Image}`);
    } catch (err) {
      console.error(err);
      setError("❌ Failed to generate QR code. Try again!");
    }
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = qrCode;
    link.download = `2fa-qr-${form.name || form.email}.png`;
    link.click();
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(to top right, #0f0c29, #302b63, #24243e)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "'Segoe UI', sans-serif",
        color: "#fff",
        padding: "20px",
      }}
    >
      <div
        style={{
          background: "rgba(255, 255, 255, 0.05)",
          borderRadius: "20px",
          padding: "40px",
          width: "100%",
          maxWidth: "450px",
          boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.18)",
          textAlign: "center",
          animation: "fadeIn 1s ease-in",
        }}
      >
        <h2 style={{ marginBottom: "25px", fontWeight: 600, color: "#00c6ff" }}>
          🔐 Secure 2FA QR Generator
        </h2>

        <input
          name="id"
          placeholder="Merchant ID"
          value={form.id}
          onChange={handleChange}
          style={inputStyle}
        />
        <input
          name="name"
          placeholder="Merchant Name"
          value={form.name}
          onChange={handleChange}
          style={inputStyle}
        />
        <input
          name="email"
          type="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          style={{ ...inputStyle, marginBottom: "18px" }}
        />

        <button
          onClick={handleGenerate}
          style={{ ...buttonStyle, width: "100%" }}
          onMouseOver={(e) =>
            (e.currentTarget.style.transform = "scale(1.05)")
          }
          onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          🚀 Generate QR
        </button>

        {error && (
          <p style={{ color: "#ff6b6b", marginTop: "12px" }}>{error}</p>
        )}

        {qrCode && (
          <div style={{ marginTop: "30px", animation: "fadeIn 0.5s ease-in" }}>
            <h4 style={{ color: "#c8f7c5", marginBottom: "15px" }}>
              Scan using Google Authenticator
            </h4>
            <img
              src={qrCode}
              alt="QR Code"
              style={{
                borderRadius: "12px",
                maxWidth: "100%",
                boxShadow: "0 0 25px 4px #00c6ff",
              }}
            />
            <br />
            <button
              onClick={handleDownload}
              style={{
                ...buttonStyle,
                background: "linear-gradient(135deg, #11998e, #38ef7d)",
                marginTop: "20px",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            >
              ⬇️ Download QR
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MerchantQR;
